module.exports = __webpack_public_path__ + "img/heibaimozhenxingdai.min.dc49f1a8.png";